import script from "./Aggregation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Aggregation.vue?vue&type=script&lang=ts&setup=true"

import "./Aggregation.vue?vue&type=style&index=0&id=cbdf96f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbdf96f4"]])

export default __exports__